
var treeLess = {};
import genaration from '../../utils/classname';
export var treeClass = genaration(treeLess, 'tree');